var _excluded = ["className"],
  _excluded2 = ["className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { Typography as AntdTypography } from 'antd';
import classNames from 'classnames';
import React from 'react';
import "./index.less";
var Title = AntdTypography.Title,
  Paragraph = AntdTypography.Paragraph,
  Text = AntdTypography.Text,
  Link = AntdTypography.Link;
var Typography = function Typography(props) {
  var className = props.className,
    restProps = _objectWithoutProperties(props, _excluded);
  var classes = classNames('iron-typography', className);
  console.log('classes', classes);
  console.log('classes', classes);
  return /*#__PURE__*/React.createElement(AntdTypography, _extends({
    rootClassName: classes
  }, restProps));
};
var ReText = function ReText(props) {
  var className = props.className,
    restProps = _objectWithoutProperties(props, _excluded2);
  var classes = classNames('iron-typography', className);
  console.log('classes', classes);
  return /*#__PURE__*/React.createElement(Text, _extends({
    rootClassName: classes
  }, restProps));
};
Typography.Text = ReText;
Typography.Link = Link;
Typography.Title = Title;
Typography.Paragraph = Paragraph;
export default Typography;